// Single source of truth for build-time config. Each deployment target
// (dev, staging, production, main...) is its own git branch, and this file
// holds the one URL for whichever branch/container you're building from.
// Update these two values per branch, then just run `npm run dev` / `npm run build`.

//devlopmment
// export const API_BASE_URL = 'http://localhost:5000/api/v1';
//devlopment-stage
// export const API_BASE_URL = 'http://172.16.1.34:30300/api/v1';
//production
// export const API_BASE_URL = 'https://wecircle-api.pptsglobal.com/api/v1';
// production-gcp-server
export const API_BASE_URL = 'https://api.wecircle.co.in/api/v1';
//app name
export const APP_NAME = 'WeCircle';
